import { useNavigate } from 'react-router-dom';

import emlogo from '../images/em-logo.svg';

const Home = () => {
    const navigate = useNavigate();

    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');

    const goToLogin = () => {
        navigate('/login');
    };

    const goToRegister = () => {
        navigate('/register');
    };

    const goToDashboard = () => {
        if (role === 'admin') {
            navigate('/admin/dashboard');
        } else if (role === 'hr') {
            navigate('/hr/dashboard');
        } else if (role === 'member') {
            navigate('/member/dashboard');
        }
    };

    return (
        <div className="lading-wrap" style={styles.container}>
        <div className="welcome-logo"><img src={emlogo} /></div>
            <h1>Welcome to EM!</h1>
            <p>A vibrant experience awaits you.</p>

            {!token ? (
                <div className="login-register">
                    <button onClick={goToLogin}>
                        Login
                    </button>
                    <button  onClick={goToRegister}>
                        Register
                    </button>
                </div>
            ) : (
                <button className="btn-fill" onClick={goToDashboard}>
                    Go to Dashboard
                </button>
            )}
        </div>
    );
};

const styles = {
    container: {
        height: '100vh'
    }
};

export default Home;
